module.exports = __webpack_public_path__ + "img/team1.6e5becd8.png";